import React, { useContext, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { UserContext } from '../../App';
import SnackBarUi from '../MaterialUI/SnackBarUi';
import './Login.css';

const Login = () => {
    const [checkBox, setCheckbox] = useState(false);
    const [oneTimeRun, setRun] = useState(true);
    const textRef = useRef(null);
    const passRef = useRef(null);
    const [cardDisplay, setCardDisplay, authentication, setAuthentication, snackBarUI, setSnackBarUI, backdropUI, setBackdropUI] = useContext(UserContext);
    const history = useHistory();
    const location = useLocation();
    const { from } = location.state || { from: { pathname: "/" } };

    const formSubmit = (event) => {
        event.preventDefault();
        if (textRef.current.value === 'morshed' && passRef.current.value === 'morshed') {
            setSnackBarUI({
                state: true,
                severity: 'success',
                message: 'Assalamualaikum, Your are Welcome Developer Naim!'
            })
            if (checkBox) {
                localStorage.setItem('login', "true");
                localStorage.setItem('username', textRef.current.value);
                localStorage.setItem('password', textRef.current.value);
            } else {
                localStorage.setItem('login', "false");
                localStorage.setItem('username', null);
                localStorage.setItem('password', null);
            }
            setAuthentication(true);
            history.replace(from);
        } else {
            setSnackBarUI({
                state: true,
                severity: 'error',
                message: 'Who the hell are you!?'
            })
        }
    }
   
    if (oneTimeRun) {
        if (localStorage.getItem('username') === 'morshed' && localStorage.getItem('password') === 'morshed') {
            setAuthentication(true);
            history.replace(from);
        }
    }

    return (
        <section className="parent-container">
            <div className="child-container">
                <h1>Welcome, Boss!</h1>
                <form onSubmit={formSubmit}>
                    <input ref={textRef} type="text" placeholder="Enter username" required />
                    <input ref={passRef} type="password" placeholder="Enter password" required />
                    <div className="d-flex align-items-center justify-content-center">
                        <input type="checkbox" onClick={() => setCheckbox(!checkBox)} />
                        <span className="ml-1">stay signed in</span>
                    </div>
                    <input className="btn btn-outline-dark" type="submit" value="LOGIN" />
                </form>
                <span className="p-3 text-primary">Forget password?</span>
                <SnackBarUi />
            </div>
        </section>
    );
};

export default Login;